<div class="custom-container">
  <div class="row justify-content-center">
    <div class="pl-6 col-md-6 align-items-center d-flex justify-content-center">
      <div class="wrapper">
        <div class="card-body">
          <img src="./assets/images/logo.png" class="logo" alt="Logo"/>
          <h5 class="card-title text-left">Seja bem-vindo(a) ao seu painel</h5>
          <form
            class="d-flex flex-column align-items-center mt-4"
            [formGroup]="loginForm"
          >
            <div class="mt-3 w-100">
              <label for="inputEmail" class="form-label">E-mail</label>
              <input
                required
                type="email"
                class="form-input"
                id="inputEmail"
                placeholder="Digite seu e-mail"
                formControlName="email"
              />
            </div>
            <div class="w-100 mt-3">
              <label for="inputPassword" class="form-label">Senha</label>

              <div class="password-input d-flex align-items-baseline">
                <input
                  class="form-input"
                  type="{{ inputType }}"
                  id="inputPassword"
                  placeholder="Digite sua senha"
                  formControlName="password"
                  (keydown.enter)="onSubmit()"
                />

                @if (showPassword) {
                <div>
                  <ng-icon
                    (click)="toggleVisibility()"
                    class="icon"
                    name="heroEye"
                    color="#D6D6D6"
                    size="26"
                  ></ng-icon>
                </div>

                } @else {
                <div>
                  <ng-icon
                    (click)="toggleVisibility()"
                    class="icon"
                    name=" heroEyeSlash"
                    color="#D6D6D6"
                    size="26"
                  ></ng-icon>
                </div>

                }
              </div>
            </div>
            <div class="pl-1 w-100 password-recovery">
              Esqueceu sua senha?
              <a
                class="forgot-password"
                [routerLink]="['/forgot-password']"
                routerLinkActive="router-link-active"
                >Recupere aqui</a
              >
            </div>
            <button
              [disabled]="loginForm.invalid"
              type="button"
              class="btn btn-no-auth"
              (click)="onSubmit()"
            >
              Entrar
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <app-slider></app-slider>
    </div>
  </div>
</div>
